// RB-MY01-PalmGarden.web/src/components/PlantForm/styles.ts

export const sectionThemes = {
  basicInfo: {
    color: '#4caf50',
    iconName: 'fas fa-info-circle'
  },
  classification: {
    color: '#2196f3',
    iconName: 'fas fa-sitemap'
  },
  description: {
    color: '#ff9800',
    iconName: 'fas fa-align-left'
  },
  landscaping: {
    color: '#9c27b0',
    iconName: 'fas fa-tree'
  },
  plantCare: {
    color: '#00bcd4',
    iconName: 'fas fa-tint'
  },
  foliarDetails: {
    color: '#8bc34a',
    iconName: 'fas fa-leaf'
  },
  floralDetails: {
    color: '#e91e63',
    iconName: 'fas fa-spa'
  },
  imagesPublish: {
    color: '#607d8b',
    iconName: 'fas fa-image'
  }
};

export const fadeIn = {
  '@keyframes fadeIn': {
    '0%': {
      opacity: 0,
      transform: 'translateY(10px)'
    },
    '100%': {
      opacity: 1,
      transform: 'translateY(0)'
    }
  },
  animation: 'fadeIn 0.3s ease-out'
};
